import conf from '../src/config/conf_prod.js';

function waterfall( tasks, clbk ) {
    let i = 0;

    const domino = function( err, data ){
        let j = i;

        if ( err ){ 
            return clbk(err, data); 
        }
        
        if ( j < tasks.length ) {
            i++;
            tasks[j](data, domino);
        } else {
            clbk(err, data);
        }
    };

    domino(null, {});
}

/**
 * 
 * @returns creates new Instance of CARAT view
 */

const boot = { 

    /**
     * 
     * @param {*} data 
     * @param {*} done 
     */
    init : function( data, done ) {

        const script = document.getElementById( conf.id ); 
        const currentScriptURL = new URL( script.src );

        done ( null,
            Object.assign(data, {
                currentScriptURL:currentScriptURL,
                currentScriptPathname : currentScriptURL.pathname.substring(0, currentScriptURL.pathname.lastIndexOf('/') ),
                scriptParams : Object.assign( {}, script.dataset )
            }, conf )
        );

    },

    /**
     * 
     * @param {*} params 
     * @param {*} done 
     */
    loadConfig : function( params, done ) {

        fetch( params.currentScriptURL.origin + params.configPath + "conf_" + params.currentScriptURL.hostname + ".json" )
    
            .then( response => {
                    return response.json();
            })
            
            .then( data => {
    
                if ( data.count === 0 ){
                    let res = new Error( "There are no panoramas saved under this guid!" ); 
                    return done( res, params );
                }
    
                Object.assign( params, data );
    
                done( null, params );
                  
            })
            .catch( err => {
                done( err, null );
            });
    
    },

    /**
     * 
     * @param {*} params 
     * @param {*} done 
     */
    getParams : function( params, done ) {
    
        // Script Params
        params.serverUrl = params.serverUrl || params.currentScriptURL.origin + "/"; // find serverUrl
        params.scriptParams.serverUrl = params.serverUrl;
    
        // Url Params
        const queryString = window.location.search;
        const urlParamsIterator = new URLSearchParams( queryString );
        const urlParams = {};
    
        for ( const [key, value] of urlParamsIterator.entries() ) {
            urlParams[ key ] = value;
        }
    
        
        Object.assign( params.scriptParams, urlParams ); 
    
        // Resolve alias: every alias value for guid, will be set as guid value
        for ( const defaultKey in params.alias ){
    
            Object.keys( params.scriptParams ).forEach( paramKey => {
                
                if ( !params.alias[ defaultKey].includes( paramKey ) ) return;
                params.scriptParams[ defaultKey ] = params.scriptParams[ paramKey ];
                
            });
        } 
    
        done( null, params );
    },

    /**
     * 
     * @param {*} params 
     * @param {*} done 
     */
    createCaratViewStyleTag : function( params, done ){

        // external UI
        const pfad = params.currentScriptURL.origin + params.stylePath + "style.css";
    
        // cretea script tag
        const styleTag = document.createElement("link");
    
        // nur für dev umschreiben
        styleTag.setAttribute( "rel", "stylesheet" );
        styleTag.setAttribute( "href", pfad );
    
        document.head.appendChild( styleTag );
    
        if ( done ) {
            done( null, params );
        }
    },

    /**
     * 
     * @param {*} params 
     * @param {*} done 
     */
    createCaratViewScript : function( params, done ){

        const pfad =  params.currentScriptURL.origin + params.currentScriptPathname+ "/" + params.appScript;
    
        // get parent node
        const script = document.getElementById( conf.id ); 
        const parent = script.parentNode;
    
        // create data-params
        const paramsString = Object.keys( params.scriptParams ).map(key => key + '=' + params.scriptParams[key]).join('&');
    
        // cretea script tag
        const caratView = document.createElement("script");
        caratView.setAttribute( "id", "caratviewapp" );
    
        // nur für dev umschreiben
        caratView.setAttribute( "type", "module" );
        caratView.setAttribute( "src", pfad );
        caratView.setAttribute( "data-params", paramsString );
    
       
        parent.appendChild( caratView );
    
        done( null, params);
    
    },

    /**
     * 
     * @param {*} err 
     * @param {*} data 
     */
    onError : function( err, data ){
        //ToDo
    }

};

/**
 * *** start ***
 */
waterfall([

    boot.init,
    boot.loadConfig,
    boot.getParams,
    boot.createCaratViewStyleTag,
    boot.createCaratViewScript

], ( err, data ) => {

    if ( err ) {
        return boot.onError( err, data );
    }

    //clean memory
    delete boot.init;
    delete boot.loadConfig;
    delete boot.getParams;
    delete boot.createCaratViewStyleTag;
    delete boot.createCaratViewScript;

    delete boot.onError;
          
});
//# sourceMappingURL=boot.m.js.map
